import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import moment from "moment";

class DigiFormDateTime extends React.Component {
  
  componentDidMount() {
      const cleanedName = this.props.name.replace(/[|&;$%@"'<>()+,]/g, "");
      const datetimeInput = `#input-${cleanedName}`;
      let widget;

      const safeOnChange = (e) => {
        if (typeof this.props.onChange === "function") {
          this.props.onChange(e);
        }
      };

      switch (this.props.type) {
        case "date":
        case 2:
          widget = $(datetimeInput)
            .kendoDatePicker({
              change: safeOnChange,
              value: this.props.value ? moment(this.props.value).toDate() : null,
            })
            .data("kendoDatePicker");

          $(datetimeInput).on("focus", function () {
            if (widget && typeof widget.open === "function") {
              widget.open("date");
            }
          });
          break;

        case "time":
        case 11:
          let timeValue = null;
          if (this.props.value && moment(this.props.value).isValid()) {
            timeValue = moment(this.props.value).toDate();
          } else {
            timeValue = moment(this.props.value, "hh:mm").toDate();
          }

          widget = $(datetimeInput)
            .kendoTimePicker({
              change: safeOnChange,
              value: this.props.value ? timeValue : null,
            })
            .data("kendoTimePicker");

          $(datetimeInput).on("focus", function () {
            if (widget && typeof widget.open === "function") {
              widget.open("time");
            }
          });
          break;

        default:
          widget = $(datetimeInput)
            .kendoDateTimePicker({
              change: safeOnChange,
              value: this.props.value ? moment(this.props.value).toDate() : null,
            })
            .data("kendoDateTimePicker");

          $(datetimeInput).on("focus", function () {
            if (widget && typeof widget.open === "function") {
              widget.open("date");

              // Open time picker after date is selected and popup is closed
              widget.dateView.popup.bind("close", function () {
                setTimeout(() => {
                  widget.open("time");
                }, 0);
              });
            }
          });
          break;
      }
    }

  datetimeInputPlaceholder = () => {
    switch (this.props.type) {
      case "date":
      case 2:
        return "mm/dd/yyyy";
      case "time":
      case 11:
        return "hh:mm";
      default:
        return "mm/dd/yyyy hh:mm";
    }
  };

  render() {
    const {
      type,
      label,
      placeholder,
      name,
      value,
      required,
      fieldErrors,
    } = this.props;

    const cleanedName = name.replace(/[|&;$%@"'<>()+,]/g, "");

    return (
      <div
        className={classnames("form-group", {
          "has-error": fieldErrors && fieldErrors.length > 0,
        })}
      >
        {label && (
          <label
            className="control-label word-wrap"
            htmlFor={`input-${cleanedName}`}
          >
            {label}
            {required ? " *" : ""}
          </label>
        )}
        <input
          id={`input-${cleanedName}`}
          placeholder={this.datetimeInputPlaceholder()}
          className="full-width"
        />
        {fieldErrors && (
          <span className="help-block">{fieldErrors.join(", ")}</span>
        )}
      </div>
    );
  }
}

DigiFormDateTime.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  required: PropTypes.bool,
  fieldErrors: PropTypes.array,
  onChange: PropTypes.func,
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

DigiFormDateTime.defaultProps = {
  required: false,
  fieldErrors: [],
};

export default DigiFormDateTime;
